/**
 * @generated SignedSource<<65ddc58d625028461cf53f05076a93e9>>
 * @relayHash 661233a47ecadf36bf6b55db313a301e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 606baac6ffac521e762bb6b0a6f0aebbd60f1bd9366f43f4a561b5a0c55143c9

import type { ConcreteRequest } from 'relay-runtime';
export type PTGraphQLPageStatus = "CURRENT" | "DRAFT" | "HISTORICAL" | "TRASHED" | "%future added value";
export type PageTreeQuery$variables = {
  contentId: string;
  isSuperAdmin: boolean;
  paginationLimit?: number | null;
  ptStatuses?: ReadonlyArray<PTGraphQLPageStatus | null> | null;
  spaceKey: string;
};
export type PageTreeQuery$data = {
  readonly currentPage: {
    readonly blank: boolean | null;
    readonly children: {
      readonly nodes: ReadonlyArray<{
        readonly blank: boolean | null;
        readonly createdDate: {
          readonly value: string;
        } | null;
        readonly hasChildren: boolean;
        readonly hasInheritedRestrictions?: boolean;
        readonly hasRestrictions?: boolean;
        readonly id: string;
        readonly links: {
          readonly webui: string | null;
        } | null;
        readonly properties: {
          readonly nodes: ReadonlyArray<{
            readonly id: string | null;
            readonly key: string | null;
            readonly value: string | null;
            readonly version: {
              readonly number: number | null;
            } | null;
          } | null> | null;
        } | null;
        readonly status: PTGraphQLPageStatus | null;
        readonly subType: string | null;
        readonly title: string | null;
        readonly type: string | null;
      } | null> | null;
      readonly pageInfo: {
        readonly hasNextPage: boolean;
      } | null;
    } | null;
    readonly createdDate: {
      readonly value: string;
    } | null;
    readonly followingSiblings: {
      readonly nodes: ReadonlyArray<{
        readonly blank: boolean | null;
        readonly createdDate: {
          readonly value: string;
        } | null;
        readonly hasChildren: boolean;
        readonly hasInheritedRestrictions?: boolean;
        readonly hasRestrictions?: boolean;
        readonly id: string;
        readonly links: {
          readonly webui: string | null;
        } | null;
        readonly properties: {
          readonly nodes: ReadonlyArray<{
            readonly id: string | null;
            readonly key: string | null;
            readonly value: string | null;
            readonly version: {
              readonly number: number | null;
            } | null;
          } | null> | null;
        } | null;
        readonly status: PTGraphQLPageStatus | null;
        readonly subType: string | null;
        readonly title: string | null;
        readonly type: string | null;
      } | null> | null;
      readonly pageInfo: {
        readonly hasNextPage: boolean;
      } | null;
    } | null;
    readonly hasChildren: boolean;
    readonly hasInheritedRestrictions?: boolean;
    readonly hasRestrictions?: boolean;
    readonly id: string;
    readonly links: {
      readonly webui: string | null;
    } | null;
    readonly nearestAncestors: {
      readonly nodes: ReadonlyArray<{
        readonly blank: boolean | null;
        readonly createdDate: {
          readonly value: string;
        } | null;
        readonly followingSiblings: {
          readonly nodes: ReadonlyArray<{
            readonly blank: boolean | null;
            readonly createdDate: {
              readonly value: string;
            } | null;
            readonly hasChildren: boolean;
            readonly hasInheritedRestrictions?: boolean;
            readonly hasRestrictions?: boolean;
            readonly id: string;
            readonly links: {
              readonly webui: string | null;
            } | null;
            readonly properties: {
              readonly nodes: ReadonlyArray<{
                readonly id: string | null;
                readonly key: string | null;
                readonly value: string | null;
                readonly version: {
                  readonly number: number | null;
                } | null;
              } | null> | null;
            } | null;
            readonly status: PTGraphQLPageStatus | null;
            readonly subType: string | null;
            readonly title: string | null;
            readonly type: string | null;
          } | null> | null;
          readonly pageInfo: {
            readonly hasNextPage: boolean;
          } | null;
        } | null;
        readonly hasChildren: boolean;
        readonly hasInheritedRestrictions?: boolean;
        readonly hasRestrictions?: boolean;
        readonly id: string;
        readonly links: {
          readonly webui: string | null;
        } | null;
        readonly previousSiblings: {
          readonly nodes: ReadonlyArray<{
            readonly blank: boolean | null;
            readonly createdDate: {
              readonly value: string;
            } | null;
            readonly hasChildren: boolean;
            readonly hasInheritedRestrictions?: boolean;
            readonly hasRestrictions?: boolean;
            readonly id: string;
            readonly links: {
              readonly webui: string | null;
            } | null;
            readonly properties: {
              readonly nodes: ReadonlyArray<{
                readonly id: string | null;
                readonly key: string | null;
                readonly value: string | null;
                readonly version: {
                  readonly number: number | null;
                } | null;
              } | null> | null;
            } | null;
            readonly status: PTGraphQLPageStatus | null;
            readonly subType: string | null;
            readonly title: string | null;
            readonly type: string | null;
          } | null> | null;
          readonly pageInfo: {
            readonly hasNextPage: boolean;
          } | null;
        } | null;
        readonly properties: {
          readonly nodes: ReadonlyArray<{
            readonly id: string | null;
            readonly key: string | null;
            readonly value: string | null;
            readonly version: {
              readonly number: number | null;
            } | null;
          } | null> | null;
        } | null;
        readonly status: PTGraphQLPageStatus | null;
        readonly subType: string | null;
        readonly title: string | null;
        readonly type: string | null;
      } | null> | null;
      readonly pageInfo: {
        readonly endCursor: string | null;
        readonly hasNextPage: boolean;
      } | null;
    } | null;
    readonly previousSiblings: {
      readonly nodes: ReadonlyArray<{
        readonly blank: boolean | null;
        readonly createdDate: {
          readonly value: string;
        } | null;
        readonly hasChildren: boolean;
        readonly hasInheritedRestrictions?: boolean;
        readonly hasRestrictions?: boolean;
        readonly id: string;
        readonly links: {
          readonly webui: string | null;
        } | null;
        readonly properties: {
          readonly nodes: ReadonlyArray<{
            readonly id: string | null;
            readonly key: string | null;
            readonly value: string | null;
            readonly version: {
              readonly number: number | null;
            } | null;
          } | null> | null;
        } | null;
        readonly status: PTGraphQLPageStatus | null;
        readonly subType: string | null;
        readonly title: string | null;
        readonly type: string | null;
      } | null> | null;
      readonly pageInfo: {
        readonly hasNextPage: boolean;
      } | null;
    } | null;
    readonly properties: {
      readonly nodes: ReadonlyArray<{
        readonly id: string | null;
        readonly key: string | null;
        readonly value: string | null;
        readonly version: {
          readonly number: number | null;
        } | null;
      } | null> | null;
    } | null;
    readonly status: PTGraphQLPageStatus | null;
    readonly subType: string | null;
    readonly title: string | null;
    readonly type: string | null;
  } | null;
  readonly ptpage: {
    readonly blank: boolean | null;
    readonly createdDate: {
      readonly value: string;
    } | null;
    readonly followingSiblings: {
      readonly nodes: ReadonlyArray<{
        readonly blank: boolean | null;
        readonly createdDate: {
          readonly value: string;
        } | null;
        readonly hasChildren: boolean;
        readonly hasInheritedRestrictions?: boolean;
        readonly hasRestrictions?: boolean;
        readonly id: string;
        readonly links: {
          readonly webui: string | null;
        } | null;
        readonly properties: {
          readonly nodes: ReadonlyArray<{
            readonly id: string | null;
            readonly key: string | null;
            readonly value: string | null;
            readonly version: {
              readonly number: number | null;
            } | null;
          } | null> | null;
        } | null;
        readonly status: PTGraphQLPageStatus | null;
        readonly subType: string | null;
        readonly title: string | null;
        readonly type: string | null;
      } | null> | null;
      readonly pageInfo: {
        readonly hasNextPage: boolean;
      } | null;
    } | null;
    readonly hasChildren: boolean;
    readonly hasInheritedRestrictions?: boolean;
    readonly hasRestrictions?: boolean;
    readonly id: string;
    readonly links: {
      readonly webui: string | null;
    } | null;
    readonly properties: {
      readonly nodes: ReadonlyArray<{
        readonly id: string | null;
        readonly key: string | null;
        readonly value: string | null;
        readonly version: {
          readonly number: number | null;
        } | null;
      } | null> | null;
    } | null;
    readonly status: PTGraphQLPageStatus | null;
    readonly subType: string | null;
    readonly title: string | null;
    readonly type: string | null;
  } | null;
  readonly space: {
    readonly homepage: {
      readonly id: string | null;
    } | null;
    readonly id: string | null;
    readonly operations: ReadonlyArray<{
      readonly operation: string | null;
      readonly targetType: string | null;
    } | null> | null;
  } | null;
};
export type PageTreeQuery = {
  response: PageTreeQuery$data;
  variables: PageTreeQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "contentId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isSuperAdmin"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "paginationLimit"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "ptStatuses"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "spaceKey"
},
v5 = {
  "kind": "Literal",
  "name": "enablePaging",
  "value": true
},
v6 = {
  "kind": "Variable",
  "name": "pageTree",
  "variableName": "paginationLimit"
},
v7 = {
  "kind": "Variable",
  "name": "spaceKey",
  "variableName": "spaceKey"
},
v8 = {
  "kind": "Variable",
  "name": "status",
  "variableName": "ptStatuses"
},
v9 = {
  "kind": "ScalarField",
  "name": "id"
},
v10 = {
  "kind": "ScalarField",
  "name": "title"
},
v11 = {
  "kind": "ScalarField",
  "name": "status"
},
v12 = {
  "kind": "ScalarField",
  "name": "value"
},
v13 = {
  "args": [
    {
      "kind": "Literal",
      "name": "format",
      "value": "MILLIS"
    }
  ],
  "concreteType": "ConfluenceDate",
  "kind": "LinkedField",
  "name": "createdDate",
  "plural": false,
  "selections": [
    (v12/*: any*/)
  ],
  "storageKey": "createdDate(format:\"MILLIS\")"
},
v14 = {
  "kind": "ScalarField",
  "name": "hasChildren"
},
v15 = {
  "kind": "ScalarField",
  "name": "blank"
},
v16 = {
  "condition": "isSuperAdmin",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "hasRestrictions"
    },
    {
      "kind": "ScalarField",
      "name": "hasInheritedRestrictions"
    }
  ]
},
v17 = {
  "kind": "ScalarField",
  "name": "type"
},
v18 = {
  "kind": "ScalarField",
  "name": "subType"
},
v19 = {
  "concreteType": "Map_LinkType_String",
  "kind": "LinkedField",
  "name": "links",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "webui"
    }
  ]
},
v20 = {
  "args": [
    {
      "kind": "Literal",
      "name": "keys",
      "value": [
        "emoji-title-published",
        "emoji-title-draft",
        "editor",
        "jira-planner-connection"
      ]
    }
  ],
  "concreteType": "PaginatedJsonContentPropertyList",
  "kind": "LinkedField",
  "name": "properties",
  "plural": false,
  "selections": [
    {
      "concreteType": "JsonContentProperty",
      "kind": "LinkedField",
      "name": "nodes",
      "plural": true,
      "selections": [
        (v9/*: any*/),
        {
          "kind": "ScalarField",
          "name": "key"
        },
        (v12/*: any*/),
        {
          "concreteType": "Version",
          "kind": "LinkedField",
          "name": "version",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "number"
            }
          ]
        }
      ]
    }
  ],
  "storageKey": "properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\",\"jira-planner-connection\"])"
},
v21 = {
  "kind": "ScalarField",
  "name": "hasNextPage"
},
v22 = [
  {
    "concreteType": "PTPage",
    "kind": "LinkedField",
    "name": "nodes",
    "plural": true,
    "selections": [
      (v9/*: any*/),
      (v10/*: any*/),
      (v11/*: any*/),
      (v13/*: any*/),
      (v14/*: any*/),
      (v15/*: any*/),
      (v16/*: any*/),
      (v17/*: any*/),
      (v18/*: any*/),
      (v19/*: any*/),
      (v20/*: any*/)
    ]
  },
  {
    "concreteType": "PTPageInfo",
    "kind": "LinkedField",
    "name": "pageInfo",
    "plural": false,
    "selections": [
      (v21/*: any*/)
    ]
  }
],
v23 = {
  "concreteType": "PTPaginatedPageList",
  "kind": "LinkedField",
  "name": "previousSiblings",
  "plural": false,
  "selections": (v22/*: any*/)
},
v24 = {
  "concreteType": "PTPaginatedPageList",
  "kind": "LinkedField",
  "name": "followingSiblings",
  "plural": false,
  "selections": (v22/*: any*/)
},
v25 = [
  {
    "alias": "currentPage",
    "args": [
      (v5/*: any*/),
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "contentId"
      },
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/)
    ],
    "concreteType": "PTPage",
    "kind": "LinkedField",
    "name": "ptpage",
    "plural": false,
    "selections": [
      (v9/*: any*/),
      (v10/*: any*/),
      (v11/*: any*/),
      (v13/*: any*/),
      (v14/*: any*/),
      (v15/*: any*/),
      (v16/*: any*/),
      (v17/*: any*/),
      (v18/*: any*/),
      (v19/*: any*/),
      (v20/*: any*/),
      {
        "concreteType": "PTPaginatedPageList",
        "kind": "LinkedField",
        "name": "nearestAncestors",
        "plural": false,
        "selections": [
          {
            "concreteType": "PTPageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              (v21/*: any*/),
              {
                "kind": "ScalarField",
                "name": "endCursor"
              }
            ]
          },
          {
            "concreteType": "PTPage",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              (v13/*: any*/),
              (v14/*: any*/),
              (v15/*: any*/),
              (v16/*: any*/),
              (v17/*: any*/),
              (v18/*: any*/),
              (v19/*: any*/),
              (v20/*: any*/),
              (v23/*: any*/),
              (v24/*: any*/)
            ]
          }
        ]
      },
      (v23/*: any*/),
      (v24/*: any*/),
      {
        "concreteType": "PTPaginatedPageList",
        "kind": "LinkedField",
        "name": "children",
        "plural": false,
        "selections": (v22/*: any*/)
      }
    ]
  },
  {
    "args": [
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/)
    ],
    "concreteType": "PTPage",
    "kind": "LinkedField",
    "name": "ptpage",
    "plural": false,
    "selections": [
      (v9/*: any*/),
      (v10/*: any*/),
      (v11/*: any*/),
      (v13/*: any*/),
      (v14/*: any*/),
      (v15/*: any*/),
      (v16/*: any*/),
      (v17/*: any*/),
      (v18/*: any*/),
      (v19/*: any*/),
      (v20/*: any*/),
      (v24/*: any*/)
    ]
  },
  {
    "args": [
      {
        "kind": "Variable",
        "name": "key",
        "variableName": "spaceKey"
      }
    ],
    "concreteType": "Space",
    "kind": "LinkedField",
    "name": "space",
    "plural": false,
    "selections": [
      (v9/*: any*/),
      {
        "concreteType": "Content",
        "kind": "LinkedField",
        "name": "homepage",
        "plural": false,
        "selections": [
          (v9/*: any*/)
        ]
      },
      {
        "concreteType": "OperationCheckResult",
        "kind": "LinkedField",
        "name": "operations",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "operation"
          },
          {
            "kind": "ScalarField",
            "name": "targetType"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Fragment",
    "name": "PageTreeQuery",
    "selections": (v25/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v4/*: any*/),
      (v3/*: any*/),
      (v0/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "PageTreeQuery",
    "selections": (v25/*: any*/)
  },
  "params": {
    "cacheID": "661233a47ecadf36bf6b55db313a301e",
    "id": "606baac6ffac521e762bb6b0a6f0aebbd60f1bd9366f43f4a561b5a0c55143c9",
    "metadata": {},
    "name": "PageTreeQuery",
    "operationKind": "query",
    "text": "query PageTreeQuery($spaceKey:String!,$ptStatuses:[PTGraphQLPageStatus],$contentId:ID!,$paginationLimit:Int,$isSuperAdmin:Boolean!){currentPage:ptpage(id:$contentId,spaceKey:$spaceKey,pageTree:$paginationLimit,status:$ptStatuses,enablePaging:true){id,title,status,createdDate(format:MILLIS){value},hasChildren,blank,hasRestrictions@include(if:$isSuperAdmin)\n    hasInheritedRestrictions@include(if:$isSuperAdmin),type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\",\"jira-planner-connection\"]){nodes{id,key,value,version{number}}},nearestAncestors{pageInfo{hasNextPage,endCursor},nodes{id,title,status,createdDate(format:MILLIS){value},hasChildren,blank,hasRestrictions@include(if:$isSuperAdmin)\n        hasInheritedRestrictions@include(if:$isSuperAdmin),type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\",\"jira-planner-connection\"]){nodes{id,key,value,version{number}}},previousSiblings{nodes{id,title,status,createdDate(format:MILLIS){value},hasChildren,blank,hasRestrictions@include(if:$isSuperAdmin)\n            hasInheritedRestrictions@include(if:$isSuperAdmin),type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\",\"jira-planner-connection\"]){nodes{id,key,value,version{number}}}},pageInfo{hasNextPage}},followingSiblings{nodes{id,title,status,createdDate(format:MILLIS){value},hasChildren,blank,hasRestrictions@include(if:$isSuperAdmin)\n            hasInheritedRestrictions@include(if:$isSuperAdmin),type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\",\"jira-planner-connection\"]){nodes{id,key,value,version{number}}}},pageInfo{hasNextPage}}}},previousSiblings{nodes{id,title,status,createdDate(format:MILLIS){value},hasChildren,blank,hasRestrictions@include(if:$isSuperAdmin)\n        hasInheritedRestrictions@include(if:$isSuperAdmin),type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\",\"jira-planner-connection\"]){nodes{id,key,value,version{number}}}},pageInfo{hasNextPage}},followingSiblings{nodes{id,title,status,createdDate(format:MILLIS){value},hasChildren,blank,hasRestrictions@include(if:$isSuperAdmin)\n        hasInheritedRestrictions@include(if:$isSuperAdmin),type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\",\"jira-planner-connection\"]){nodes{id,key,value,version{number}}}},pageInfo{hasNextPage}},children{nodes{id,title,status,createdDate(format:MILLIS){value},hasChildren,blank,hasRestrictions@include(if:$isSuperAdmin)\n        hasInheritedRestrictions@include(if:$isSuperAdmin),type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\",\"jira-planner-connection\"]){nodes{id,key,value,version{number}}}},pageInfo{hasNextPage}}},ptpage(spaceKey:$spaceKey,pageTree:$paginationLimit,status:$ptStatuses,enablePaging:true){id,title,status,createdDate(format:MILLIS){value},hasChildren,blank,hasRestrictions@include(if:$isSuperAdmin)\n    hasInheritedRestrictions@include(if:$isSuperAdmin),type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\",\"jira-planner-connection\"]){nodes{id,key,value,version{number}}},followingSiblings{nodes{id,title,status,createdDate(format:MILLIS){value},hasChildren,blank,hasRestrictions@include(if:$isSuperAdmin)\n        hasInheritedRestrictions@include(if:$isSuperAdmin),type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\",\"jira-planner-connection\"]){nodes{id,key,value,version{number}}}},pageInfo{hasNextPage}}},space(key:$spaceKey){id,homepage{id},operations{operation,targetType}}}"
  }
};
})();

(node as any).hash = "f7e2a69b86e03d256ceaf9a0f482bed1";

export default node;
